import { z } from 'zod/v3';
import { createPaginationSchema } from '../../common/utils/schema';
import { zIsoDate } from '../../common/utils/schema/zIsoDate';
import { ChangedBySchema } from '../../user';
import { DataObjectVersionSchema } from '../../dataobject/schema/DataObjectVersionSchema';
import { zIsoDateTime } from '../../common/utils/schema/zIsoDateTime';

export const ValidationDashboardDataObjectVersionSchema = z.object({
  id: z.number(),
  dataObjectVersion: DataObjectVersionSchema,
  sequenceNumber: z.number(),
});

export const ValidationDashboardSchema = z.object({
  id: z.number(),
  dashboardTypeId: z.number(),
  externalCode: z.string(),
  name: z.string(),
  description: z.string().nullable(),

  valueDate: zIsoDate().nullable(),
  valueDateFrom: zIsoDate().nullable(),
  valueDateTo: zIsoDate().nullable(),

  versionSelectionRuleId: z.number().nullable(),
  version1SelectionRuleId: z.number().nullable(),
  version2SelectionRuleId: z.number().nullable(),

  versions: z.array(ValidationDashboardDataObjectVersionSchema),

  createdBy: ChangedBySchema.nullable(),
  createdAt: zIsoDateTime().nullable(),
  modifiedAt: zIsoDateTime().nullable(),
  modifiedBy: ChangedBySchema.nullable(),
});

export const ValidationDashboardListPageSchema = createPaginationSchema(
  ValidationDashboardSchema,
);
